module.exports = __webpack_public_path__ + "490d85a3be6826a974d972c9cdbcd2cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/cta/icon_catalog_light.png
// module id = 730
// module chunks = 0 1